(function() {
    'use strict';

    angular
        .module('app')
        .directive('routeLoadingIndicator', routeLoadingIndicator);

    routeLoadingIndicator.$inject = ['$rootScope'];
    
    function routeLoadingIndicator ($rootScope) {
        // Usage:
        //     <routeLoadingIndicator></routeLoadingIndicator>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'E',
            template: "<div class='col-lg-12' ng-if='isRouteLoading'><h1>Loading <i class='fa fa-cog fa-spin'></i></h1></div>"
        };
        return directive;

        function link(scope, element, attrs) {
            scope.isRouteLoading = false;

            $rootScope.$on('$stateChangeStart', function () {
                scope.isRouteLoading = true;
            });

            $rootScope.$on('$stateChangeSuccess', function () {
                scope.isRouteLoading = false;
            });
        }
    }

})();